export const errorTypes = {
  INVALID_TYPE: 'INVALID_TYPE',
  NULL: 'NULL',
  UNDEFINED: 'UNDEFINED',
  CUSTOM: 'CUSTOM',

  // String
  EMPTY_STRING: 'EMPTY_STRING',
  EXCEED_LENGTH: 'EXCEED_LENGTH',
  INVALID_STRING: 'INVALID_STRING',
  NO_STANDARD_PREFIX: 'NO_STANDARD_PREFIX',
  NOT_STRING: 'NOT_STRING',

  // Double
  INVALID_DOUBLE_NUMBER: 'INVALID_DOUBLE_NUMBER',
  NOT_DOUBLE_NUMBER: 'NOT_DOUBLE_NUMBER',

  // Int
  INVALID_INT_NUMBER: 'INVALID_INTEGER_NUMBER',
  NOT_INT_NUMBER: 'NOT_INT_NUMBER',

  // Date
  NOT_DATE: 'NOT_DATE',
  INVALID_DATE: 'INVALID_DATE',

  // Function
  NOT_FUNCTION: 'NOT_FUNCTION',

  // Boolean
  NOT_BOOLEAN: 'NOT_BOOLEAN',
};
